<template>
  <div class="signup">
    <!--<v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="350px"
      transition="dialog-transition"
    >
      <v-btn flat slot="activator" class="dark white--text">Signup</v-btn>
      <v-card>
        <v-card-title primary-title>
          <h2>Signup</h2>
        </v-card-title>
        <v-card-text>
          <v-form class="px-3" ref="form">
            <v-text-field
              label="Username"
              v-model="username"
              prepend-icon="person"
              :rules="inputRules"
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              v-model="password"
              prepend-icon="lock"
              :rules="inputRules"
            ></v-text-field>

            <v-spacer></v-spacer>
            <v-btn flat class="success mx-0 mt-3" @click="submit" :loading="loading">Login</v-btn>
            <v-btn flat class="error mx-1 mt-3" @click="dialog = false">Cancel</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>-->
    <div class="text-xs-center">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="250"
        :nudge-left="250"
        offset-y
        right
      >
        <v-btn flat slot="activator" @click="e1 = 1" class="dark white--text">signup</v-btn>

        <v-stepper v-model="e1" dark>
          <v-stepper-header v-show="false">
            <v-stepper-step :complete="e1 > 1" step="1"></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2"></v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content class="pa-0" step="1">
              <v-form class="py-3 px-4" ref="form">
                <v-text-field
                  label="Username"
                  v-model="username"
                  prepend-icon="person"
                  :rules="inputRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Password"
                  v-model="password"
                  prepend-icon="lock"
                  :rules="inputRules"
                ></v-text-field>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form class="px-3" ref="form">
                <v-text-field
                  label="Username"
                  v-model="username"
                  prepend-icon="person"
                  :rules="inputRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Password"
                  v-model="password"
                  prepend-icon="lock"
                  :rules="inputRules"
                ></v-text-field>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form class="px-3" ref="form">
                <v-text-field
                  label="Username"
                  v-model="username"
                  prepend-icon="person"
                  :rules="inputRules"
                  required
                ></v-text-field>
                <v-text-field
                  label="Password"
                  v-model="password"
                  prepend-icon="lock"
                  :rules="inputRules"
                ></v-text-field>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
          <v-btn flat @click="e1 = 0" right>Cancel</v-btn>
          <v-btn color="success" @click="e1 = 2" right flat>Next</v-btn>
        </v-stepper>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      inputRules: [v => v.length >= 3 || "Minimun length is 3 characters"],
      loading: false,
      e1: 0
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        //console.log(this.username, this.password);
      }
    }
  }
};
</script>